export const purchaseUrl = 'https://combo-completo-jumping.impultienda.ar/checkout'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/3tLB3sq5jtCik6DSZuCuPk/ChatGPT_Image_27_ago_2026,_08_52_49_p.m..png'

export const heroStats = [
  ['+800', 'instructores confían'],
  ['5', 'Módulos listos'],
  ['3', 'Bonos incluidos'],
  ['4,9/5', 'calificación ⭐'],
] as const

export const testimonials = [
  {
    initials: 'MG',
    name: 'María G.',
    place: 'Buenos Aires',
    text: 'Organicé todo el año en una tarde. El banco de clases me ahorra 5 horas cada semana.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    place: 'Rosario · Studio Fitness',
    text: 'La guía de adaptación me permite enseñar a mayores de 70 años con seguridad total.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    place: 'Mendoza · Instructor Certificado',
    text: 'Mis clases de Avanzado por fin tienen profundidad. Cambió mi negocio.',
  },
]

export const developedTestimonials = [
  {
    initials: 'FA',
    name: 'Florencia A.',
    place: 'Mar del Plata · 34 años · Instructora de Jumping',
    result: 'De 3 a 11 clases llenas',
    text: 'Pasaba los domingos armando coreos que después no funcionaban. Con los Módulos 1 y 2 armé una progresión de 16 semanas y en dos meses pasé a 11 clases llenas. Mis alumnas se quedan porque ven que avanzan.',
  },
  {
    initials: 'VM',
    name: 'Verónica M.',
    place: 'Córdoba · 41 años · Dueña de estudio',
    result: 'Retención del 92%',
    text: 'Mi problema era el grupo mixto: chicas de 25 y señoras de 62 en la misma clase. Con el Módulo 4 cada alumna tiene su versión del mismo paso. La retención pasó de 55% a 92%.',
  },
  {
    initials: 'GS',
    name: 'Gabriela S.',
    place: 'Neuquén · 47 años · Especialista en adultos mayores',
    result: '8 meses sin incidentes en el grupo 70+',
    text: 'Quería abrir un grupo de adultos mayores pero me daba miedo la responsabilidad. Con el protocolo del Módulo 5 abrí el grupo: 14 alumnas de 70 a 81 años y ocho meses sin un solo incidente.',
  },
]

export const modules = [
  {
    icon: '🏃‍♀️',
    name: 'Módulo 1 — Principiantes',
    period: 'Semana 1-8 · Familiarización + Confianza',
    content: [
      '4 clases Principiante listas + 20 pasos base',
      'Protocolo de seguridad completo',
      'Adaptaciones por edad (6 a 70+ años)',
      'Checklist de ejecución + FAQ del nivel',
    ],
  },
  {
    icon: '🔥',
    name: 'Módulo 2 — Intermedio',
    period: 'Semana 9-16 · Coordinación + Resistencia',
    content: [
      '5 clases Intermedio listas',
      'Combinaciones de 2 y 3 pasos',
      'Matriz de progresión',
      'Errores comunes + correcciones',
    ],
  },
  {
    icon: '⚡',
    name: 'Módulo 3 — Avanzado',
    period: 'Semana 17-24 · Maestría + Flow',
    content: [
      '5 clases Avanzado listas',
      '10 movimientos de alta complejidad',
      'Estructura de coreografía narrativa + HIIT',
      'Trabajo de flow mental',
    ],
  },
  {
    icon: '👶',
    name: 'Módulo 4 — Por edades y capacidades',
    period: '9 protocolos · De 6 a 70+ años',
    content: [
      'Niños, adolescentes, jóvenes y adultos',
      'Pre-mayores 56-70 y mayores 70+',
      'Embarazadas (con autorización médica)',
      'Personas con capacidades diferentes',
    ],
  },
  {
    icon: '🧓',
    name: 'Módulo 5 — Adultos mayores',
    period: '70+ años · Seguridad máxima',
    content: [
      'Evaluación pre-clase y protocolo de primera clase',
      'Progresión semana 1-4 y mes 2-3',
      'Equilibrio, fuerza y cardio seguro',
      'Adaptaciones por 10 condiciones de salud',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '🎁',
    'Banco de 85 clases',
    '52 clases semanales para un año completo + 12 temáticas + 20 de recuperación + 15 de transición.',
    '$12.000',
  ],
  [
    '02',
    '📚',
    'Biblioteca de 155 combinaciones',
    'Simples, intermedias y avanzadas + 20 bloques temáticos + 15 fusiones extremas.',
    '$14.000',
  ],
  [
    '03',
    '🧩',
    'Guía completa de adaptación',
    'Sistema para adaptar cualquier clase a cualquier persona. 50 páginas de protocolos.',
    '$12.000',
  ],
] as const

export const pains = [
  'Domingos enteros armando clases que “más o menos sirven”.',
  'Siempre los mismos pasos: no tenés un banco de combinaciones.',
  'Grupos con distintos niveles juntos y sin material diferenciado.',
  'Alumnos que se aburren a las 4 semanas y no vuelven.',
]

export const faqs = [
  [
    '¿Sirve para todos los niveles?',
    'Sí. Son 5 módulos progresivos: Principiante, Intermedio, Avanzado, Por Edades y Adultos Mayores. Elegís por dónde empezar según tu alumno.',
  ],
  [
    '¿Cómo recibo el material?',
    'Al pagar recibís un correo automático con el link de descarga. Bajás todos los PDF y los videos en menos de 5 minutos.',
  ],
  [
    '¿Tiene garantía real?',
    'Sí, 7 días. Escribís a compradigitalyaa@gmail.com y te devolvemos el 100%. Sin justificaciones. La tasa de devoluciones es menor al 0,5%.',
  ],
  [
    '¿Necesito certificación previa?',
    'No. Si ya sabés saltar en trampolín rinde más, y si recién empezás como instructor los Módulos 1 y 4 te llevan paso a paso.',
  ],
  [
    '¿Sirve para adultos mayores o personas con limitaciones?',
    'Es uno de los puntos más fuertes: el Módulo 5 está dedicado al grupo 70+ y el Módulo 4 cubre embarazadas y capacidades diferentes.',
  ],
  [
    '¿Cómo puedo pagar?',
    'En pesos argentinos con Mercado Pago, tarjeta o transferencia, con cuotas según tu banco.',
  ],
] as const

export const recentPurchases = [
  ['Camila Ferreyra', 'Rosario, Santa Fe'],
  ['Julieta Ibáñez', 'Córdoba Capital, Córdoba'],
  ['Rocío Maidana', 'La Plata, Buenos Aires'],
  ['Agustina Rojas', 'Mendoza, Mendoza'],
  ['Belén Sosa', 'Mar del Plata, Buenos Aires'],
  ['Martín Quiroga', 'San Miguel de Tucumán, Tucumán'],
  ['Lucía Benítez', 'Neuquén, Neuquén'],
  ['Natalia Ojeda', 'Salta, Salta'],
] as const
